import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import Header from './components/Header';
import Constraints from './components/Constraints';
import Help from './components/Help';
import ScreenShot from './components/ScreenShot';
import Footer from './components/Footer';

class App extends React.Component {
  state = {
    // isDark: false
  }
  isDark = false;
  changeTheme = () => {
    this.isDark = !this.isDark;
    if (this.isDark) {
      document.body.classList.remove('light_theme')
      document.body.classList.add('dark_theme')
    } else {
      document.body.classList.remove('dark_theme')
      document.body.classList.add('light_theme')
    }
  }
  render () {
    const {isDark} = this.state;
    return (
      <Router>
        <div className={`App ${isDark ? 'dark' : 'light'}_theme`}>
          <div style={{ outline: 'none' }} tabIndex={-1} role="group">
            <main>
              <Header toogleTheme={() => this.changeTheme()/*this.setState({ isDark: !isDark })*/}/>
              <Switch>
                <Route path="/help">
                  <Help/>
                </Route>
                <Route path="/releases">
                  <ScreenShot />
                </Route>
                <Route path="/">
                  <Constraints />
                </Route>
              </Switch>
              <Footer />
            </main>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
